import React from 'react';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeContentVersion: (value: string) => void;
}

export const ContentVersionField: React.FC<IProps> = React.memo(({ changeContentVersion }) => (
	<FormInputNew
		testId="ContentVersionField"
		name="contentVersion"
		label="contentVersionLabel"
		placeholder="contentVersionPlaceholder"
		onChange={changeContentVersion}
	/>
));
